import type { Overview } from '../../types/Overview';

export const overviewBaseFeatureConfig: Overview = {
    applyPositionsForTitleCount: false,
    getSumPerTypeMarketValue: false,
    getSumPerTypeTotalMarketValue: false,
    hideFilterSecurityType: false,
    showFilterSubAccount: false,
    showOnlyLengthOfVisibleModels: false,
    showPriceTooltip: false,
    showTradingButton: false,
    sortAttribute: 'title',
    stockValueTooltip: false,
    sumValueFromMarketValue: false,
    sumValueFromPositions: false,
    sumValueFromPerformance: false,
    totalMarketValueFromOtherTitleModels: false,
    totalMarketValueFromPositions: false,
};
